import React, { createContext, useState, useContext } from 'react';
import { SearchData, PresenceFilter } from '../../models/SearchElements'
import { Artwork, ArtworkStub } from "../../models/Artwork";
interface FilterContextType {
    filterParams: SearchData;
    artworks: ArtworkStub[];
    filteredArtworks: ArtworkStub[];
    currentArtworkId: number;
    currentArtworkIndex: number;
    setFilterParams: (filter: SearchData) => void;
    resetFilter: (clientId: number) => void;
    updateFilter: (update: Partial<SearchData>) => void;
    setArtworks: (artworks: ArtworkStub[]) => void;
    setFilteredArtworks: (filteredArtworks: ArtworkStub[]) => void;
    setCurrentArtworkId: (artworkId: number) => void;
    setCurrentArtworkIndex: (index: number) => void;
    hasActiveFilters: boolean;
}

const FilterContext = createContext<FilterContextType | undefined>(undefined);

export const FilterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    const [artworks, setArtworks] = useState<ArtworkStub[]>([]);
    const [filteredArtworks, setFilteredArtworks] = useState<ArtworkStub[]>([]);
    const [currentArtworkId, setCurrentArtworkId] = useState<number>(0);
    const [currentArtworkIndex, setCurrentArtworkIndex] = useState<number>(0);

    const [filterParams, setFilterParams] = useState<SearchData>({
        description: '',
        artistIds: [],
        categoryIds: [],
        locations: [],
        minValue: null,
        maxValue: null,
        currency: '',
        valuationType: "acquisition",
        acquiredFrom:null,
        acquiredTo: null,
        imageStatus: "any",
        acquisitionValueStatus: "any",
        insuranceValueStatus: "any",
        fairMarketValueStatus: "any",
    });


    const updateFilter = (update: Partial<SearchData>) => {
        setFilterParams((prev) => ({ ...prev, ...update }));
    };

    const resetFilter = (clientId: number) => {
        setFilterParams({
            clientId: clientId,
            portfolioId: null,
            description: '',
            artistIds: [],
            categoryIds: [],
            locations: [],
            minValue: null,
            maxValue: null,
            currency: '',
            valuationType: "acquisition",
            acquiredFrom: null,
            acquiredTo: null,
            imageStatus: "any",
            acquisitionValueStatus: "any",
            insuranceValueStatus: "any",
            fairMarketValueStatus: "any",
        });
    }

    const hasActiveFilters = (() => {
        return (
            filterParams.description?.trim() !== '' ||
            (filterParams.categoryIds && filterParams.categoryIds.length > 0) ||
            (filterParams.locations && filterParams.locations.length > 0) ||
            (filterParams.artistIds && filterParams.artistIds.length > 0) ||
            filterParams.minValue != null ||
            filterParams.maxValue != null ||
            filterParams.acquiredFrom != null ||
            filterParams.acquiredTo != null ||
            (filterParams.portfolioId != null && filterParams.portfolioId > 0)
        );
    })();

    return (
        <FilterContext.Provider value={{
            filterParams, artworks, filteredArtworks, currentArtworkId, currentArtworkIndex,
            setFilterParams, resetFilter, updateFilter, setArtworks, setFilteredArtworks, setCurrentArtworkId, setCurrentArtworkIndex,
            hasActiveFilters
        }}>
            {children}
        </FilterContext.Provider>
    );
};

export const useFilter = (): FilterContextType => {
    const context = useContext(FilterContext);
    if (!context) {
        throw new Error('useFilter must be used within a FilterProvider');
    }
    return context;
};